import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/services';
import { Helpers } from 'src/app/helpers';

@Component({
    selector: 'medpt-server-error',
    templateUrl: './server-error.component.html',
    styleUrls: ['./server-error.component.scss'],
    standalone: false
})
export class ServerErrorComponent implements OnInit {
  dashboardUrl: string = "";
  constructor(private loaderService: LoaderService) {
    this.dashboardUrl = Helpers.getApplicationUrl() + "/Dashboard";
  }

  ngOnInit(): void {
    this.loaderService.hideLoader();
  }

}
